module.exports = __webpack_public_path__ + "static/banner-one-shape3-f31abf2d3bd8e515ee041bd3641904a6.png";